// extracted by mini-css-extract-plugin
export default {"primaryColor":"#191919","secondaryColor":"#fff","auxColor":"#be1e2c","complementaryColorDark":"#191919","complementaryColorLight":"#1c1c1a"};